import React, { useRef, useState } from 'react';
import Tools from '../../util/tools';
import { componentDidMount } from '../Lifecycle';
import './index.scss';



const INNER_SCROLL_CLS = `com-nav-menu-scroll`;
const INNER_SCROLL_CLS_LEFT = `${INNER_SCROLL_CLS}-left`;
const INNER_SCROLL_CLS_RIGHT = `${INNER_SCROLL_CLS}-right`;
const INNER_SCROLL_CLS_BOTH = `${INNER_SCROLL_CLS_LEFT} ${INNER_SCROLL_CLS_RIGHT}`;

const NavMenu = ({ children, className, needShadow = false, ...props }) => {

  const innerRef = useRef();
  const [scrollCls, setScrollCls] = useState('');

  const setShadowCls = (mode) => {
    if (needShadow === false) {
      return;
    }
    if (mode === 'left') {
      setScrollCls(INNER_SCROLL_CLS_LEFT);
    } else if (mode === 'right') {
      setScrollCls(INNER_SCROLL_CLS_RIGHT);
    } else if (mode === 'both') {
      setScrollCls(INNER_SCROLL_CLS_BOTH);
    } else if (mode === 'none') {
      setScrollCls('');
    }
  }

  const onScroll = Tools.debounce((e) => {
    if (needShadow) {
      const scrollLeft = innerRef.current.scrollLeft;
      const scrollWidth = innerRef.current.scrollWidth;
      if (scrollLeft > 0 && scrollLeft + 375 < scrollWidth) {
        setShadowCls('both');
      } else if (innerRef.current.scrollLeft === 0) {
        setShadowCls('right');
      } else {
        setShadowCls('left');
      }
    }
  }, 100);

  componentDidMount(() => {
    if (innerRef.current.scrollWidth > 375) {
      setShadowCls('right');
    }
  });

  return (
    <div
      className={`com-nav-menu ${className ? className : ''} ${scrollCls}`}
      {...props}
    >
      <div ref={innerRef} className={`com-nav-menu-inner`} onScroll={onScroll}>
        {children}
      </div>
    </div>
  )
}

NavMenu.Item = ({ children, className, active, ...props }) => {
  return (
    <div
      className={`com-nav-menu-item ${className ? className : ''} ${active ? ' active' : ''}`}
      {...props}
    >
      {children}
    </div>
  )
}

export default NavMenu;